import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import ReactPlaceholder from 'react-placeholder';

import {
	makeStyles,
	Typography, useTheme
} from '@material-ui/core';

import AuthorizedUserContext from "../utils/AuthorizedUserContext.js";
import Constants from "../utils/Constants.js";
import InsightsImg from "../assets/insights.png";

const styles = makeStyles(theme => ({
	teamComment: {
		fontWeight: 500,
		color: Constants.COLORS.PRIMARY.DARK_GREY,
		marginBottom: theme.spacing(2)
	},
	title: {
		fontWeight: 500,
		color: Constants.COLORS.PRIMARY.DARK_GREY,
	},
	description: {
		marginBottom: theme.spacing(1),
		color: Constants.COLORS.SECONDARY.GREY,
		fontWeight: 300
	},
	logo: {
		height: '2rem',
		marginRight: theme.spacing(1),
		marginBottom: theme.spacing(-1)
	},
}));

function Analysis(props) {
	const theme = useTheme();
	const authenticatedUser = useContext(AuthorizedUserContext);

	let classes = styles(),
		{ alertInsights, ready } = props;

	const insightList = alertInsights?.[0] || []
	const analysis = [];

	Analysis.propTypes = {
		alertInsights: PropTypes.object,
		ready: PropTypes.bool,
		createdAt: PropTypes.instanceOf(Date)
	};
	try {
		if (typeof (insightList.insights) !== 'object')
			insightList.insights = JSON.parse(insightList.insights);
	} catch {
		insightList.insights = insightList.insights.replace(/[\u201C\u201D]/g, '"');
	}
	if (insightList?.insights && typeof (insightList?.insights) === 'string') {
		const titleRegex = /\*\*"(.*?)"\*\*|\*\*(.*?)\*\*/g;
		const descRegex = /–\s*(.+?)(?=\d+\.|$)/gs;
		let titleMatch, descMatch;
		while ((titleMatch = titleRegex.exec(insightList.insights)) !== null && (descMatch = descRegex.exec(insightList.insights)) !== null) {
			analysis.push({
				analysisTitle: titleMatch[1] || titleMatch[2],
				analysisDesc: descMatch[1].trim()
			});
		}
	}
	else if (insightList?.insights && typeof (insightList?.insights) === 'object') {
		insightList.insights.forEach((insight) => {
			analysis.push({
				analysisTitle: insight.important_phrase,
				analysisDesc: insight.topic.join(', ') + ': ' + insight.explanation
			});
		});
	}

	if (insightList?.insights && !analysis.length) {
		const fpRegex = /\d+\./g
		const fpMatch = fpRegex.exec(insightList.insights);
		console.log("fpMatch", fpMatch, insightList.insights);
		if (fpMatch == null) {
			analysis.push({
				analysisTitle: "No Immediate Concerns Detected",
				analysisDesc: "This signal has been flagged as a potential false positive. Our analysis found no indicators of risk to student mental health or safety. If the content doesn’t raise any concerns on your review, you can safely ignore this alert. We apologize for the inconvenience, and want you to know that these insights will help improve our language model over time to better serve your school community."
			});
		}
	}
	console.log("analysis", analysis);
	return (
		<div className={``}>
			{authenticatedUser && (
				<ReactPlaceholder
					type='rect'
					ready={ready}
					style={{ height: 30, borderRadius: 20 }}>
					<Typography className={classes.teamComment}>
						<img src={InsightsImg} alt="Insights" className={classes.logo} />
						N.O.R.A Insights
					</Typography>
					{analysis.length > 0 && analysis.map((item, index) => (
						<>
							<Typography style={{ marginBottom: theme.spacing(1) }}>
								<span className={classes.title}>"{item.analysisTitle}"</span>{` - `}
								<span className={classes.description}>{item.analysisDesc}</span>
							</Typography>
						</>))}
				</ReactPlaceholder>
			)}
		</div>
	);
}

Analysis.propTypes = {
	alertInsights: PropTypes.object,
	ready: PropTypes.bool,
};

export default Analysis;
